export enum BaseCanceledTypeEnum {
  holiday = 'holiday',
  illness = 'illness',
  other = 'other',
  offline = 'offline',
  timeOffCompensation = 'time_off_compensation',
  freeShift = 'free_shift',
  unexcusedAbsence = 'unexcused_absence',
  canceled = 'canceled',
  employmentTerminated = 'employment_terminated',
}
